import type { GeoScatterPoint } from "@/shared/charts/components/geo-scatter-chart/types";

/** Returns the closest editable point within the supplied screen-space hit radius. */
export function findEditablePointAtPixel(
  points: GeoScatterPoint[],
  target: [number, number],
  toPixel: (point: [number, number]) => [number, number] | null,
  hitRadius: number
): GeoScatterPoint | null {
  let nearest: GeoScatterPoint | null = null;
  let nearestDistanceSquared = hitRadius * hitRadius;

  for (const point of points) {
    const pixel = toPixel(point.position);
    if (!pixel) continue;
    const distanceSquared = (pixel[0] - target[0]) ** 2 + (pixel[1] - target[1]) ** 2;
    if (distanceSquared <= nearestDistanceSquared) {
      nearest = point;
      nearestDistanceSquared = distanceSquared;
    }
  }

  return nearest;
}
